export default "__VITE_ASSET__tv7PqSiP__"